export const PORTAL_HEADER = "PORTAL_HEADER";

export const USER_TYPE_ANONYME = "ANONYME";
export const USER_TYPE_ADMIN = "ADMIN";
export const USER_TYPE_USER = "USER";
